import type { RequestScopeSnapshot } from '../../../contexts/RequestScopeContext';
import type { SavedAttachment } from '../../../services/attachmentService';
import type { Request } from '../../../types';

export interface SummaryProps {
  formData?: Record<string, unknown>;
  updateFormData?: (field: string, value: string) => void;
  request?: Request;
  /** When viewing an opened request in edit mode, overlay unsaved field values onto `request` for read-only Summary preview. */
  editedData?: Record<string, unknown>;
  isEditing?: boolean;
  /**
   * #997 C3: sections edited this session (dirty keys, e.g. `smallUpsConfigurations`).
   * When a repeatable section is dirty, an empty edited array is authoritative in the
   * Summary resolvers, so deleting every unit does not resurrect the persisted rows
   * before save. Same signal the section bridges + step-layout guard use.
   */
  dirtyFields?: Set<string>;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  requestId?: number;
  isAdmin?: boolean;
  /**
   * Create flow: scope from App shell (main bundle). Web lazy chunks may not share
   * {@link RequestScopeContext} with Sidebar — this prop mirrors nav scope (#1330).
   */
  navScopeSnapshot?: RequestScopeSnapshot | null;
}

/**
 * Summary step: presentation and aggregation logic currently live in `Summary.tsx`.
 * Extract stateful helpers here as the step grows.
 */
export function useSummaryStepContext(): Record<string, never> {
  return {};
}
